import { ModulesMap, ModulesConfigMap } from '@/config/data/modulesMaps'
import { _apiRequestWrap } from '../apiService'

function _getDoneWorksMeasures(options = {}) {
	return _apiRequestWrap(
		ModulesMap.DONE_WORKS_MEASURES,
		ModulesConfigMap[ModulesMap.DONE_WORKS_MEASURES].GET_DONE_WORKS_MEASURES,
		options
	)
}
function _getDoneWorksMeasurePreview(options = {}) {
	return _apiRequestWrap(
		ModulesMap.DONE_WORKS_MEASURES,
		ModulesConfigMap[ModulesMap.DONE_WORKS_MEASURES].GET_DONE_WORKS_MEASURE_PREVIEW,
		options
	)
}
function _getDoneWorksMeasurePopup(options = {}) {
	return _apiRequestWrap(
		ModulesMap.DONE_WORKS_MEASURES,
		ModulesConfigMap[ModulesMap.DONE_WORKS_MEASURES].GET_DONE_WORKS_MEASURE_POPUP,
		options
	)
}

function _createDoneWorksMeasure(options = {}) {
	return _apiRequestWrap(
		ModulesMap.DONE_WORKS_MEASURES,
		ModulesConfigMap[ModulesMap.DONE_WORKS_MEASURES].CREATE_DONE_WORKS_MEASURE,
		options
	)
}

function _getDoneWorksMeasure(options = {}) {
	return _apiRequestWrap(
		ModulesMap.DONE_WORKS_MEASURES,
		ModulesConfigMap[ModulesMap.DONE_WORKS_MEASURES].GET_DONE_WORKS_MEASURE,
		options
	)
}

function _patchDoneWorksMeasure(options = {}) {
	return _apiRequestWrap(
		ModulesMap.DONE_WORKS_MEASURES,
		ModulesConfigMap[ModulesMap.DONE_WORKS_MEASURES].PATCH_DONE_WORKS_MEASURE,
		options
	)
}

function _patchDoneWorksMeasureBulkUpdate(options = {}) {
	return _apiRequestWrap(
		ModulesMap.DONE_WORKS_MEASURES,
		ModulesConfigMap[ModulesMap.DONE_WORKS_MEASURES].PATCH_DONE_WORKS_MEASURE_BULK_UPDATE,
		options
	)
}

function _postDoneWorksMeasureBulkCreate(options = {}) {
	return _apiRequestWrap(
		ModulesMap.DONE_WORKS_MEASURES,
		ModulesConfigMap[ModulesMap.DONE_WORKS_MEASURES].POST_DONE_WORKS_MEASURE_BULK_CREATE,
		options
	)
}

function _putDoneWorksMeasure(options = {}) {
	return _apiRequestWrap(
		ModulesMap.DONE_WORKS_MEASURES,
		ModulesConfigMap[ModulesMap.DONE_WORKS_MEASURES].PUT_DONE_WORKS_MEASURE,
		options
	)
}

function _deleteDoneWorksMeasure(options = {}) {
	return _apiRequestWrap(
		ModulesMap.DONE_WORKS_MEASURES,
		ModulesConfigMap[ModulesMap.DONE_WORKS_MEASURES].DELETE_DONE_WORKS_MEASURE,
		options
	)
}

export default {
	[ModulesConfigMap[ModulesMap.DONE_WORKS_MEASURES].GET_DONE_WORKS_MEASURES]: _getDoneWorksMeasures,
	[ModulesConfigMap[ModulesMap.DONE_WORKS_MEASURES].GET_DONE_WORKS_MEASURE_PREVIEW]: _getDoneWorksMeasurePreview,
	[ModulesConfigMap[ModulesMap.DONE_WORKS_MEASURES].GET_DONE_WORKS_MEASURE_POPUP]: _getDoneWorksMeasurePopup,
	[ModulesConfigMap[ModulesMap.DONE_WORKS_MEASURES].CREATE_DONE_WORKS_MEASURE]: _createDoneWorksMeasure,
	[ModulesConfigMap[ModulesMap.DONE_WORKS_MEASURES].GET_DONE_WORKS_MEASURE]: _getDoneWorksMeasure,
	[ModulesConfigMap[ModulesMap.DONE_WORKS_MEASURES].PATCH_DONE_WORKS_MEASURE]: _patchDoneWorksMeasure,
	[ModulesConfigMap[ModulesMap.DONE_WORKS_MEASURES].PATCH_DONE_WORKS_MEASURE_BULK_UPDATE]: _patchDoneWorksMeasureBulkUpdate,
	[ModulesConfigMap[ModulesMap.DONE_WORKS_MEASURES].POST_DONE_WORKS_MEASURE_BULK_CREATE]: _postDoneWorksMeasureBulkCreate,
	[ModulesConfigMap[ModulesMap.DONE_WORKS_MEASURES].PUT_DONE_WORKS_MEASURE]: _putDoneWorksMeasure,
	[ModulesConfigMap[ModulesMap.DONE_WORKS_MEASURES].DELETE_DONE_WORKS_MEASURE]: _deleteDoneWorksMeasure,
}